export const miniCartForcedMessageSources = ['CART_UPDATE'];
